const API_BASE = '/api/clients';

export const getClients = async (authenticatedFetch) => {
  const response = await authenticatedFetch(API_BASE);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to fetch clients', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to fetch clients');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const createClient = async (authenticatedFetch, clientData) => {
  const response = await authenticatedFetch(API_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(clientData),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to create client', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to create client');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const getClientDetail = async (authenticatedFetch, clientId) => {
  const response = await authenticatedFetch(`${API_BASE}/${clientId}`);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to fetch client', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to fetch client');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const updateClient = async (authenticatedFetch, clientId, clientData) => {
  const response = await authenticatedFetch(`${API_BASE}/${clientId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(clientData),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to update client', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to update client');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const deleteClient = async (authenticatedFetch, clientId) => {
  const response = await authenticatedFetch(`${API_BASE}/${clientId}`, {
    method: 'DELETE',
  });
  if (!response.ok && response.status !== 204) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to delete client', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to delete client');
    err.code = errorData.code || null;
    throw err;
  }
};

export const getClientActivities = async (authenticatedFetch, clientId, limit = 50, offset = 0) => {
  const response = await authenticatedFetch(`${API_BASE}/${clientId}/activities?limit=${limit}&offset=${offset}`);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to fetch activities', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to fetch activities');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const createActivity = async (authenticatedFetch, clientId, activityData) => {
  const response = await authenticatedFetch(`${API_BASE}/${clientId}/activities`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(activityData),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to create activity', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to create activity');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};
